export default "__VITE_ASSET__8d7cf7fa__"